import { render, staticRenderFns } from "./SummaryWidget.vue?vue&type=template&id=23da76f0&scoped=true"
import script from "./SummaryWidget.vue?vue&type=script&lang=js"
export * from "./SummaryWidget.vue?vue&type=script&lang=js"
import style0 from "./SummaryWidget.vue?vue&type=style&index=0&id=23da76f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23da76f0",
  null
  
)

export default component.exports